import { ExplicitlyCompletableTask } from './explicitly-completable-task';

export abstract class TimeBudgettedTask extends ExplicitlyCompletableTask {
  minuteBudget?: number;

  constructor() {
    super();
    this.type = 'TimeBudgettedTask';
  }
}
